import { translate } from "@kaltura/mediaspace-shared-utils";

export const notOnlySpaces = (systemName: string) => {
    return systemName.trim().length > 0;
};

export const generateErrorMessage = (type: string) => {
    let message;
    switch (type) {
        case "isUnique":
            message = translate("Name already assigned to another destination");
            break;
        case "notOnlySpaces":
            message = translate("Name can not include only spaces");
            break;
        default:
            message = translate("Field is required");
    }
    return message;
};
